import parsePhoneNumber, { getCountryCallingCode, CountryCode } from 'libphonenumber-js';

// Turn an ISO 3166-1 alpha-2 code into its flag emoji using
// Unicode regional indicator symbols (A => 0x1F1E6).
function flagEmoji(code: string): string {
    return code
        .toUpperCase()
        .replace(/./g, c => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

export class Flags {
    static unknownAreas = ['XX', 'T1'];

    static setCurrentFlag(code: string) {
        const icon = document.getElementById('country-icon');
        if (!code || this.unknownAreas.includes(code)) {
            icon.textContent = '';
        } else {
            icon.textContent = flagEmoji(code);
        }
    }

    static setCurrentPrefix(code: string) {
        const input = document.getElementById('number') as HTMLInputElement;
        if (!this.unknownAreas.includes(code)) {
            input.value = `+${getCountryCallingCode(code as CountryCode)} `;
        }
        input.focus();
        // firefox focus issue workaround
        const tmp = input.value;
        input.value = '';
        input.value = tmp;
    }

    static guessCountryCode(number: string) {
        const parsed = parsePhoneNumber(number);
        if (parsed) {
            this.setCurrentFlag(parsed.country);
        } else {
            this.setCurrentFlag('XX');
        }
    }
}
